<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <div class="input-group">
        <input type='tel'
               class="form-control"
               pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
               :placeholder="placeholder"
               ref="phoneNumber"
               :value="value"
               :disabled="disabled"
               @input="updateValue"
               :aria-label="{label}">
      </div>
      <div v-if="validator && validator.$error && validator.$dirty">
         <div class="validation-error" v-for="key in Object.keys(validator.$params)" v-if="!validator[key]">{{ validatorMsgMap[key] }}</div>
      </div>
   </div>
</template>

<script>
export default {
  name: "PhoneNumberInput",
  props: {
     label: {
        type: String,
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: String,
     },
     validatorMsgMap: {
        type: Object,
        default: null,
     },
     validator: {
        type: Object,
        default: null,
     }
  },
  data(){
    return{
      
    }
  },
  methods:{
    updateValue(){
      let x = this.$refs.phoneNumber.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.$refs.phoneNumber.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      this.$emit("input", this.$refs.phoneNumber.value);
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
